import axios from 'axios'

class CartService {
    AddtoCard({ addToCardApi, Sku, UnitOfMeasure, languageCode }) {
    return axios.get(addToCardApi, {
        params: {
            Sku,
            UnitOfMeasure,
            LanguageCode: languageCode,
            QtyOrdered: 1
        }
    });}
}

const implementation = new CartService();
export default implementation;